module.exports = __webpack_public_path__ + "static/media/underconstruction.d8c1f57c.png";